import { toast } from "./toast";

/* Copying a URL, with the failure handled once.

   `navigator.clipboard` is refused in plenty of ordinary setups — an insecure
   origin, a browser that has not seen a user gesture it likes, a locked-down
   profile — and it fails by rejecting, not by throwing where you wrote the
   call. Every place that copies an overlay URL therefore needs the same
   fallback sentence, which is why it lives here rather than in each of them. */
export async function copyToClipboard(value: string, what = "Copied"): Promise<boolean> {
  if (!value) return false;
  try {
    await navigator.clipboard.writeText(value);
    toast(what, "ok");
    return true;
  } catch {
    toast("Couldn't copy", "error");
    return false;
  }
}
